export default __webpack_public_path__ + "static/media/iit.887e0736.jpg";